import { render, staticRenderFns } from "./OpportunitiesEstimatedPotentialsForm.vue?vue&type=template&id=4b1fb131&"
import script from "./OpportunitiesEstimatedPotentialsForm.vue?vue&type=script&lang=js&"
export * from "./OpportunitiesEstimatedPotentialsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports